import React, { useState, useEffect } from 'react';
import { usePage } from '@inertiajs/react';
import classNames from 'classnames';

const IconSuccess = () => (
	<svg
		className="ml-4 mr-2 flex-shrink-0 w-4 h-4 text-white fill-current"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
	>
		<polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
	</svg>
);

const IconDanger = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth={1.5}
		stroke="currentColor"
		className="ml-4 mr-2 flex-shrink-0 w-4 h-4 text-white fill-current"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
		/>
	</svg>
);

const ButtonClose = ({ color, onClick }) => {
	const className = classNames('block  w-2 h-2 fill-current', {
		'text-red-700 group-hover:text-red-800': color === 'red',
		'text-green-700 group-hover:text-green-800': color === 'green'
	});
	return (
		<button
			onClick={onClick}
			type="button"
			className="focus:outline-none group mr-2 p-2"
		>
			<svg
				className={className}
				xmlns="http://www.w3.org/2000/svg"
				width="235.908"
				height="235.908"
				viewBox="278.046 126.846 235.908 235.908"
			>
				<path d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" />
			</svg>
		</button>
	);
};

export default () => {
	const [visible, setVisible] = useState(true);
	const { flash, errors } = usePage().props;
	const numOfErrors = Object.keys(errors).length;

	useEffect(() => {
		setVisible(true);

		return () => {
			setVisible(false);
		};
	}, [flash, errors]);

	return (
		<div>
			{flash.success && visible && (
				<div className="my-3 flex items-center justify-between bg-green-500 rounded max-w-3xl mx-auto">
					<div className="flex items-center">
						<IconSuccess />
						<div className="py-4 text-white text-sm font-medium">
							{flash.success}
						</div>
					</div>
					<ButtonClose onClick={() => setVisible(false)} color="green" />
				</div>
			)}
			{(flash.error || numOfErrors > 0) && visible && (
				<div className="my-3 flex items-center justify-between bg-red-500 rounded max-w-3xl mx-auto">
					<div className="flex items-center">
						<IconDanger />
						<div className="py-4 text-white text-sm font-medium">
							{flash.error && flash.error}
							{numOfErrors === 1 && (
								<span>{errors[Object.keys(errors)[0]]}</span>
							)}
							{numOfErrors > 1 && (
								<div>
									<span>{`The following errors were detected:`}</span>
									<ul>
										{Object.keys(errors).map(key => (
											<li key={key}>{errors[key]}</li>
										))}
									</ul>
								</div>
							)}
						</div>
					</div>
					<ButtonClose onClick={() => setVisible(false)} color="red" />
				</div>
			)}
		</div>
	);
};
